import React, { useState, useEffect } from 'react';
import axios from 'axios';
import JsBarcode from 'jsbarcode';
import './OperatorBadges.css';

/**
 * Printable Operator Badge Sheet
 * Generates barcodes for all operators for easy scanning
 */
function OperatorBadges() {
  const [operators, setOperators] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOperators();
  }, []);

  const fetchOperators = async () => {
    try {
      const response = await axios.get('/api/operators');
      setOperators(response.data);
      setLoading(false);

      // Generate barcodes after render
      setTimeout(() => {
        response.data.forEach(op => {
          const element = document.getElementById(`barcode-${op.id}`);
          if (element) {
            JsBarcode(element, op.barcode, {
              format: 'CODE128',
              width: 2,
              height: 60,
              displayValue: true,
              fontSize: 14,
              margin: 10
            });
          }
        });
      }, 100);
    } catch (error) {
      console.error('Error fetching operators:', error);
      setLoading(false);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  if (loading) {
    return <div className="badges-loading">Loading operators...</div>;
  }

  return (
    <div className="operator-badges-page">
      <div className="badges-header no-print">
        <h1>Operator Badges</h1>
        <p>Print this sheet - badges fit on standard 8.5x11 paper</p>
        <button className="print-btn" onClick={handlePrint}>
          Print Badges
        </button>
      </div>

      <div className="badges-grid">
        {operators.map(op => (
          <div key={op.id} className="badge-card">
            <div className="badge-name">{op.first_name} {op.last_name}</div>
            <svg id={`barcode-${op.id}`}></svg>
            <div className="badge-code">{op.barcode}</div>
          </div>
        ))}
      </div>

      {/* Print instructions */}
      <div className="print-instructions no-print">
        <h3>Instructions</h3>
        <ol>
          <li>Click "Print Badges" to print this page</li>
          <li>Badges print in a 3-column grid on 8.5x11 paper</li>
          <li>Laminate or place in badge holders (optional)</li>
          <li>Operators scan their badge barcode to log in at stations</li>
        </ol>
      </div>
    </div>
  );
}

export default OperatorBadges;
